import { clearDeviceSession } from "../infrastructure/deviceApi";
import { exitDemo, isDemoActive } from "../infrastructure/demo";

/**
 * Desconecta la terminal y saca al usuario a la pantalla de pareo.
 *
 * Vive en un solo lugar porque el modo demo necesita un paso extra: si sólo se borrara la
 * sesión, `maybeStartDemo` volvería a activarlo en el reload y "Salir" no liberaría nunca al
 * usuario. Ya pasó una vez (bug del botón Salir del demo, 2026-07-29) y la causa fue tener
 * dos caminos de salida distintos.
 */
export function salirDeLaTerminal(): void {
  clearDeviceSession();
  if (isDemoActive()) {
    exitDemo(); // borra el flag lpos.demo y recarga a "/"
    return;
  }
  window.location.replace("/");
}
